import { Box, Typography } from '@mui/material';

interface Props {
	title: string;
	text?: string;
	subtext?: string;
}

export const FormHeader1 = (props: Props) => {
	return (
		<Box>
			<Typography variant="h3">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
};

export const FormHeader2 = (props: Props) => {
	return (
		<Box>
			<Typography variant="h4">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
};
export const FormHeader3 = (props: Props) => {
	return (
		<Box component={'div'}>
			<Typography variant="h5">{props.title}</Typography>
			{props.text && <Typography variant="body1">{props.text}</Typography>}
		</Box>
	);
};
